import React, { FC } from 'react';
import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { BUTTON_TYPE, ButtonComponent } from '../ButtonComponent';
import clsx from 'clsx';

import './ErrorNotificationComponent.scss';

interface Props {
  title: string | JSX.Element;
  text?: string | JSX.Element;
  containerAdditionalClass?: string;
  bodyAdditionalClass?: string;
  primaryButtonName?: string;
  primaryButtonType?: BUTTON_TYPE;
  primaryButtonAction?: () => void | Promise<void>;
  primaryButtonAdditionalClass?: string;
  primaryButtonLoading?: boolean;
  primaryButtonWithoutUnderline?: boolean;

  secondaryButtonName?: string;
  secondaryButtonAction?: () => void | Promise<void>;
  secondaryButtonAdditionalClass?: string;
  secondaryButtonType?: BUTTON_TYPE;
  secondaryButtonLoading?: boolean;
  secondaryButtonWithoutUnderline?: boolean;
}
export const ErrorNotificationComponent: FC<Props> = (props) => {

  const {
    title,
    text,
    containerAdditionalClass,
    bodyAdditionalClass,
    primaryButtonAction,
    primaryButtonName,
    primaryButtonType,
    primaryButtonAdditionalClass,
    primaryButtonLoading,
    primaryButtonWithoutUnderline,
    secondaryButtonName,
    secondaryButtonAction,
    secondaryButtonAdditionalClass,
    secondaryButtonType,
    secondaryButtonLoading,
    secondaryButtonWithoutUnderline,
  } = props;

  return (
    <div className={clsx('card error-notification-component', containerAdditionalClass)}>
      <div className={clsx('card-body', bodyAdditionalClass)} >
        <div className="d-flex align-items-start">
          <FontAwesomeIcon
            icon={faTriangleExclamation}
            width={16}
            className="h-20px mt-1 me-5 text-danger"
          />
          <div>
            <div className="fs-4 fw-bolder">{title}</div>
            <div className="fs-6 mt-3">{text}</div>
            {
              (primaryButtonName || secondaryButtonName) && (
                <div className="d-flex align-items-center mt-5">
                  {
                    primaryButtonName && (
                      <ButtonComponent
                        additionalClass={clsx('btn-sm fs-5', primaryButtonAdditionalClass)}
                        buttonType={primaryButtonType}
                        onButtonClick={primaryButtonAction}
                        buttonName={primaryButtonName}
                        loading={primaryButtonLoading}
                        withoutUnderline={primaryButtonWithoutUnderline}
                      />
                    )
                  }
                  {
                    secondaryButtonName && (
                      <ButtonComponent
                        additionalClass={clsx('btn-sm fs-5 ms-10', secondaryButtonAdditionalClass)}
                        buttonType={secondaryButtonType}
                        onButtonClick={secondaryButtonAction}
                        buttonName={secondaryButtonName}
                        loading={secondaryButtonLoading}
                        withoutUnderline={secondaryButtonWithoutUnderline}
                      />
                    )
                  }
                </div>
              )
            }
          </div>
        </div>

      </div>
    </div>
  );
};